import React, { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { useApiQuery } from "@/lib/useApiQuery";
import { RefreshCcw } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export function LastSynced() {
  const [busy, setBusy] = useState(false);
  const queryClient = useQueryClient();
  const { user } = useAuth();
  const canRun = user?.role === "admin";
  const { data: status } = useApiQuery(["syncStatus"], "/sync/status", {
    refetchInterval: 30000,
    staleTime: 0,
  });

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/sync/run");
      queryClient.setQueryData(["syncStatus"], data);
      toast.success("Sync complete", { description: `${data.sites_synced} sites • ${data.points_synced} points` });
    } catch (e) {
      toast.error("Sync failed", { description: e?.response?.data?.detail || e.message });
    } finally {
      setBusy(false);
    }
  };

  const time = status?.finished_at ? new Date(status.finished_at).toLocaleTimeString() : "never";
  const ok = status?.state === "ok";
  return (
    <div className="flex items-center gap-3" data-testid="last-synced-indicator">
      <span className={`inline-block h-2 w-2 rounded-full ${ok ? "bg-[#156F5B] pulse-dot" : "bg-amber-500"}`} />
      <span className="k-sublabel">Synced • {time}</span>
      {canRun && (
        <button data-testid="sync-now-btn" onClick={run} disabled={busy} className="k-btn-outline !py-1 !px-3 !text-[11px]">
          <RefreshCcw className={`h-3 w-3 ${busy ? "animate-spin" : ""}`} /> Sync
        </button>
      )}
    </div>
  );
}
